import { TemplateOverrides } from './template.overrides.request';
import { TrainingEmailEventTypes } from './training.email.event.types';

export class SendTestEmailsForTrainingEventRequest {
    TrainingEventID: number;
    TrainingEmailEventType: TrainingEmailEventTypes;
    TestEmails: string[];
    TemplateOverrides: TemplateOverrides;
}
